export const dialogEventHook = {
  open: createEventHook<DialogOpenPayload>(),
  close: createEventHook<DialogClosePayload>(),
};

interface DialogOpenPayload {
  id: string;
  binding?: Record<string, unknown>;
}

interface DialogClosePayload {
  id: string;
  confirmed?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any;
}

export interface DialogOpenOptions<T> {
  onConfirm?: (payload: T) => void;
  onCancel?: () => void;
}

export const useDialog = (id: string) => {
  return {
    open<T>(binding?: Record<string, unknown>, options?: DialogOpenOptions<T>) {
      dialogEventHook.open.trigger({ id, binding });

      return new Promise<void>((resolve) => {
        const { off } = dialogEventHook.close.on((event) => {
          if (event.id !== id) return;

          off();

          if (event.confirmed) {
            options?.onConfirm?.(event.payload);
          } else {
            options?.onCancel?.();
          }

          return resolve();
        });
      });
    },
    async close(options?: Omit<DialogClosePayload, "id">) {
      dialogEventHook.close.trigger({
        id,
        ...options,
      });

      return nextTick();
    },
  };
};
